module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?fc03f7f15facede623faa7666c7d1f5a";